if (!customElements.get('hero-slider')) {
  class HeroSlider extends HTMLElement {
    selectors = {
      swiper: '.swiper',
      pagination: '.js-slider-dots',
    };
    settings = {
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      autoplay: this.hasAttribute('slider-autoplay')
        ? {
            delay: this.getAttribute('slider-autoplay'),
          }
        : false,
      on: {
        slideChange: function () {
          // Pause video in the previous slide
          const previousSlide = this.slides[this.previousIndex];
          const current = this.slides[this.activeIndex];
          const currentVideos = current.querySelectorAll('video');
          const videos = previousSlide.querySelectorAll('video');

          videos.forEach((video) => {
            video.pause();
          });

          currentVideos.forEach((video) => {
            if (video.parentElement?.style?.display != 'none') {
              video.play();
            }
          });
        },
      },
    };
    slider = undefined;
    id = undefined;
    dotContainers = undefined;

    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      const swiper = this.querySelector(this.selectors.swiper);
      if (!swiper) return;

      this.slider = new Swiper(swiper, this.settings);
      this.dotContainers = this.querySelectorAll(this.selectors.pagination);
      for (const dotContainer of this.dotContainers) {
        dotContainer.addEventListener('click', (event) =>
          this.onDotClick(event),
        );
      }

      if (Shopify.designMode) {
        this.addEventListener(
          'shopify:block:select',
          this.handleBlockSelect.bind(this),
        );
      }
    }

    /**
     * Handle Shopify admin section block select.
     * @param {Object} e Event
     */
    handleBlockSelect(e) {
      const targetIndex = Number(e.target?.getAttribute('data-slide-index'));

      if (!Number.isNaN(targetIndex)) {
        this.slider.slideTo(targetIndex);
      }
    }

    /**
     * Handle dot click.
     *
     * @param {Event} event
     */
    onDotClick(event) {
      const index = event.target.getAttribute('data-dot-index');
      if (!index) return;
      this.slider.slideTo(index);
    }
  }
  customElements.define('hero-slider', HeroSlider);
}
